export enum PlatformAccessStatusEnum {
  WEB_APPROVED = 1 << 0,
  WEB_REQUESTED = 1 << 1,
  APP_APPROVED = 1 << 2,
  APP_REQUESTED = 1 << 3,
}
